(function(angular){
	'use strict';
	
	var planStructureBarObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			portfolio: '<',
			defaultReitId: '<'
		},
		controller: [
			'$filter',
			'$rootScope',
			'$timeout',
			'CapitalStackFactory',
			PlanStructureBarFunction
		],
		controllerAs: 'planStructureBar'
	};
	
	angular
		.module('portfolioAllocationChartModule')
		.component('planStructureBar', planStructureBarObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/view-plan/plan-structure-bar.html';
	}
	
	function PlanStructureBarFunction(
		$filter,
		$rootScope,
		$timeout,
		CapitalStackFactory){

		var planStructureBar = this;
		var debtEquityBreakdown;

		function getActiveBreakdown(debtEquityBreakdown, reitId) {
			
			var activeBreakdown;

			if(angular.isDefined(reitId)) {
				activeBreakdown = $filter('filter')(debtEquityBreakdown.debtEquityBreakdownByReit, {reitId: reitId}, true)[0];
			} else {
				activeBreakdown = debtEquityBreakdown;
			}

			return activeBreakdown;
		}

		function setActiveBreakdown(debtEquityBreakdown, reitId) {
			
			var activeBreakdown = getActiveBreakdown(debtEquityBreakdown, reitId);

			if(angular.isDefined(activeBreakdown)) {
				planStructureBar.debt = activeBreakdown.debt;
				planStructureBar.equity = activeBreakdown.equity;
				planStructureBar.enabled = true;
			} else {
				planStructureBar.debt = undefined;
				planStructureBar.equity = undefined;
				planStructureBar.enabled = false;				
			}
		}

		planStructureBar.$onChanges = function(changeObj) {
			debtEquityBreakdown = CapitalStackFactory.getDebtEquityBreakdown(planStructureBar.portfolio);
			setActiveBreakdown(debtEquityBreakdown, planStructureBar.defaultReitId);
		};

		$rootScope.$on('reit.mouseOver', function(event, reitId) {
			var parsedReitId = parseInt(reitId);
			setActiveBreakdown(debtEquityBreakdown, parsedReitId);
		});

		$rootScope.$on('reit.mouseOut', function() {
			var clearActiveReit = $timeout(function() {
				setActiveBreakdown(debtEquityBreakdown, planStructureBar.defaultReitId);
			}, 100);

			$rootScope.$on('reit.mouseOver', function() {
				$timeout.cancel(clearActiveReit);
			});
		});
	}
})(window.angular);